import axiosInstance from '@api/axiosInstance';
import RhfRtlProvider from '@dev/rhf-rtl-provider';
import { DevTool } from '@hookform/devtools';
import { LoadingButton } from '@mui/lab';
import {
    Box,
    Checkbox,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Stack,
    TextField,
} from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const EditGroup = ({ open, onClose, group }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const defaultValues = {
        name: group?.name || '',
        description: group?.description || '',
        todo: group?.todo || false,
    };

    const {
        register,
        control,
        formState: { isDirty, errors },
        handleSubmit,
        reset,
    } = useForm({ defaultValues });

    useEffect(() => {
        if (open) reset(defaultValues);
    }, [open]);

    const { mutate: createGroup, isPending: isCreating } = useMutation({
        mutationFn: data => axiosInstance.post('/contacts/groups', data),
        onSuccess: res => {
            navigate({ to: res.data.id });
        },
    });

    const { mutate: updateGroup, isPending: isUpdating } = useMutation({
        mutationFn: data =>
            axiosInstance.put(`/contacts/groups/${group.id}`, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['group', group.id] });
            onClose();
        },
    });

    const handleSave = group ? updateGroup : createGroup;
    const isSaving = isCreating || isUpdating;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                {group ? t('Edit Group') : t('Create Group')}
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <TextField
                        label={t('Group Name')}
                        fullWidth
                        variant="outlined"
                        {...register('name', {
                            required: {
                                value: true,
                                message: t('Group name is required'),
                            },
                        })}
                        error={!!errors.name}
                        helperText={errors.name?.message}
                    />
                    <TextField
                        label={t('Description')}
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        {...register('description')}
                    />
                    {/* <todo-groups>
                        <Controller
                            name="todo"
                            control={control}
                            render={({ field: { value, ...restField } }) => (
                                <FormControlLabel
                                    checked={value}
                                    control={<Checkbox {...restField} />}
                                    label={t('Task Group')}
                                />
                            )}
                        />
                    </todo-groups> */}
                    {/* <FormControlLabel
                        // checked={group.todo}
                        control={<Checkbox />}
                        label={t('To Do Group')}
                        {...register('todo')}
                    /> */}
                    <Box display="flex" justifyContent="center">
                        <LoadingButton
                            variant="filled"
                            disabled={!isDirty}
                            onClick={handleSubmit(handleSave)}
                            loading={isSaving}
                        >
                            {t('Save')}
                        </LoadingButton>
                    </Box>
                </Stack>
                <RhfRtlProvider>
                    <DevTool control={control} />
                </RhfRtlProvider>
            </DialogContent>
        </Dialog>
    );
};

export default EditGroup;
